/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-22 16:14:31
 * @LastEditTime: 2019-07-22 16:14:31
 * @LastEditors: your name
 */
import Vue from 'vue'
import Router from 'vue-router'
import author from '@/views/author'
import login from '@/views/login'
import activity from '@/views/activity/list'
import activityDetail from '@/views/activity/detail'
import activityBrand from '@/views/activity/brand'
import activityShare from '@/views/activity/share'
import living from '@/views/activity/living'
import confirmOrder from '@/views/activity/confirmOrder'
import activityRegisterSubmit from '@/views/activity/register/submit'
import activityRegisterDetail from '@/views/activity/register/detail'
import mine from '@/views/mine/mine'
import withdraw from '@/views/mine/withdraw/edit'
import withdrawSuccess from '@/views/mine/withdraw/success'
import certification from '@/views/mine/certification/edit'
import certificationSuccess from '@/views/mine/certification/success'
import certificationDetail from '@/views/mine/certification/detail'
import modify from '@/views/mine/modify/index'
import modifyName from '@/views/mine/modify/name'
import modifyMobile from '@/views/mine/modify/mobile'
import myTeam from '@/views/team/myTeam'
import joinTeam from '@/views/team/joinTeam'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '活动详情',
      component: activityDetail
    },
    {
      path: '/login',
      name: '短信验证',
      component: login
    },
    {
      path: '/author',
      name: '星客联盟',
      component: author
    },
    {
      path: '/activity',
      name: '活动列表',
      component: activity
    },
    {
      path: '/activityDetail',
      name: '活动详情',
      component: activityDetail
    },
    {
      path: '/activityBrand',
      name: '查看品牌',
      component: activityBrand
    },
    {
      path: '/activityShare',
      name: '星任务',
      component: activityShare
    },
    {
      path: '/activityRegisterSubmit',
      name: '提交活动信息',
      component: activityRegisterSubmit
    },
    {
      path: '/activityRegisterDetail',
      name: '查看报名信息',
      component: activityRegisterDetail
    },
    {
      path: '/mine',
      name: '个人中心',
      component: mine
    },
    {
      path: '/withdraw',
      name: '提现',
      component: withdraw
    },
    {
      path: '/withdrawSuccess',
      name: '提现成功',
      component: withdrawSuccess
    },
    {
      path: '/certification',
      name: '实名认证',
      component: certification
    },
    {
      path: '/certificationSuccess',
      name: '实名认证',
      component: certificationSuccess
    },
    {
      path: '/certificationDetail',
      name: '实名认证',
      component: certificationDetail
    },
    {
      path: '/modify',
      name: '个人中心',
      component: modify
    },
    {
      path: '/modifyName',
      name: '设置名字',
      component: modifyName
    },
    {
      path: '/modifyMobile',
      name: '换绑',
      component: modifyMobile
    },
    {
      path: '/myTeam',
      name: '我的战队',
      component: myTeam
    },
    {
      path: '/joinTeam',
      name: '加入战队',
      component: joinTeam
    },
    {
      path: '/living',
      name: '直播',
      component: living
    },
    {
      path: '/confirmOrder',
      name: '订单信息',
      component: confirmOrder
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js